import { ProfileTypeKeys } from '@/redux/slices/profileSwitchSlice';

export const PROFILE_TYPES = {
  corporateServiceProviders: {
    id: 0,
    value: 'corporateServiceProviders',
    label: 'Corporate Service Provider',
    header_label: 'Corporate Service Provider',
    selectLabel: 'Select your corporate service provider firm',
    description: undefined,
  },
  groupOfCompanies: {
    id: 1,
    value: 'groupCompanies',
    label: 'Group of Companies',
    header_label: 'Group of Companies',
    description:
      'You are authorised to transact with ACRA on behalf of the entities listed below.',
    selectLabel: 'Select group of companies',
  },
  insolvencyPractitioners: {
    id: 2,
    value: 'insolvencyPractitioners',
    label: 'Insolvency Professionals',
    header_label: 'Insolvency Professionals',
    description:
      'You are the insolvency practitioner/approved liquidator for the client entities listed below.',
    selectLabel: 'Select insolvency firm',
  },
  myEntities: {
    id: 3,
    value: 'myEntities',
    label: 'My Entities',
    header_label: 'My Entities',
    description: 'You are a position holder of the entities listed below',
    selectLabel: undefined,
  },
  officialReceivers: {
    id: 4,
    value: 'officialReceivers',
    label: 'Appointed Official Receiver',
    header_label: 'Appointed Official Receiver',
    description:
      'You are the Official Receiver appointed to act on behalf of the client entities listed below.',
    selectLabel: 'Select insolvency firm',
  },
  officialReceiver: {
    id: 5,
    value: 'officialReceiver',
    label: 'Official Receiver (SIP)',
    header_label: 'Official Receiver (SIP)',
    description:
      'You are the Official Receiver appointed for Simplified Insolvency Programme.\nTo file the transactions for an entity, search for the entity using its name or UEN to retrieve its information.',
    selectLabel: 'Select insolvency firm',
  },
} as const;

export const PROFILE_TABLE_SORT_LABELS = [
  {
    label: 'Sort by: Alphabetical (A-Z)',
    paginationLabel: 'From A-Z',
  },
  {
    label: 'Sort by: Alphabetical (Z-A)',
    paginationLabel: 'From Z-A',
  },
  {
    label: 'Sort by: Latest updated',
    paginationLabel: 'From latest updated',
  },
  {
    label: 'Sort by: Earliest updated',
    paginationLabel: 'From earliest updated',
  },
];

export const PROFILE_TYPE_KEY_MAP: Record<string, ProfileTypeKeys> = {
  GC: 'groupOfCompanies',
  CSP: 'corporateServiceProviders',
  ME: 'myEntities',
  IP: 'insolvencyPractitioners',
  OR: 'officialReceivers',
};
